export function isSuccessResult(x) {
    return 'rootKey' in x;
}
export var KeyRecoveryEvent;
(function (KeyRecoveryEvent) {
    KeyRecoveryEvent["KeysRecovered"] = "KeysRecovered";
})(KeyRecoveryEvent || (KeyRecoveryEvent = {}));
